var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0625 6.5C9.0625 7.63909 8.13909 8.5625 7 8.5625C5.86091 8.5625 4.9375 7.63909 4.9375 6.5C4.9375 5.36091 5.86091 4.4375 7 4.4375C8.13909 4.4375 9.0625 5.36091 9.0625 6.5Z",
    stroke: "#FF7926",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4375 6.5C12.4375 11.0566 7 15.0446 7 15.0446C7 15.0446 1.5625 11.0566 1.5625 6.5C1.5625 3.49695 3.99695 1.0625 7 1.0625C10.003 1.0625 12.4375 3.49695 12.4375 6.5Z",
    stroke: "#FF7926",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.e823a32afff96913ef6e1dd8096ac9da.svg";
export { ForwardRef as ReactComponent };